var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-completed",style:({ width: (_vm.completed + "%") })})])}
var staticRenderFns = []

export { render, staticRenderFns }